import { useEffect } from "react";

const SITE_NAME = "Commune de Gandiaye";
const DEFAULT_DESCRIPTION = "Portail officiel de la Commune de Gandiaye, Sénégal. Actualités, démarches administratives, projets de développement et services municipaux.";

const setMeta = (name, content, attr = "name") => {
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const PageSEO = ({ title, description, path = "/", image }) => {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    const metaDesc = description || DEFAULT_DESCRIPTION;
    const url = `https://gandiaye.sn${path}`;
    const ogImage = image || "/gandiaye-hero.jpg";

    document.title = fullTitle;
    setMeta("description", metaDesc);
    setMeta("og:type", metaDesc, "property");
    setMeta("og:url", url, "property");
    setMeta("og:title", fullTitle, "property");
    setMeta("og:description", metaDesc, "property");
    setMeta("og:image", ogImage, "property");
    setMeta("og:site_name", SITE_NAME, "property");
    setMeta("og:locale", "fr_SN", "property");
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", metaDesc);
    setMeta("twitter:image", ogImage);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
  }, [title, description, path, image]);

  return null;
};

export default PageSEO;
